import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Link } from "react-router-dom";
import {Stories} from './../../utils/stories';

export default class StoryFooter extends Component {
  constructor(props) {
      super(props);
      this.state={};
  }
  render() {
    let story = this.props.story;
    let next;
    let article;
    for (var i = 0; i < Stories.length; i++) {
      if(Stories[i].link == this.props.story){
        if(i != Stories.length -1){
          article = Stories[i+1];
        } else{
          article =  Stories[0];
        }
      }
    }
    if(!article) return null
    return (
      <Fade bottom distance="0%" duration={1500}>
        <div className="row primary-background large-padding full-width" style={{alignItems:"center", justifyContent:"center"}}>
          <div style={{flexGrow:1}}>
            <h6 className="white">{'Next'}</h6>
            <h4 className="white">{article.title}</h4>
            <p className="white subheading">{article.description}</p>
          </div>
          <Link to={article.link}><img style={{justifySelf:"flex-end", width:"60px"}} src={"/images/next-white.png"} /></Link>
        </div>
      </Fade>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/storyFooter/index.js